/**
 * ContentSection Component
 *
 * A wrapper for main content sections in learn pages.
 * Provides consistent spacing, borders, and layout.
 *
 * Props:
 * - id: Used for TOC linking and scroll targets
 * - title: Optional section title (h2)
 * - children: Section content
 *
 * Usage:
 * <ContentSection id="introduction" title="Getting Started">
 *   <p>Content here...</p>
 * </ContentSection>
 *
 * Used in: All learn pages
 */

import React from "react";
import styles from "../../styles/learn/ContentSection.module.css";

interface ContentSectionProps {
    id: string;
    title?: string;
    children: React.ReactNode;
}

export default function ContentSection({ id, title, children }: ContentSectionProps) {
    return (
        <section id={id} className={styles.contentSection}>
            {title && <h2 className={styles.sectionTitle}>{title}</h2>}
            <div className={styles.sectionContent}>{children}</div>
        </section>
    );
}
